import React, { useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import { setIsShowToast } from '../../store/slices/toastSlice';
import s from './Toast.module.css';

export default function Toast({ message }) {
    const open = useSelector((state) => state.toast);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setIsShowToast(false));
    };

    useEffect(() => {
        dispatch(setIsShowToast(false));
    }, []);

    return (
        <div className={s.toastWrapper}>
            <Snackbar
                resumeHideDuration={2000}
                TransitionProps={{ timeout: { enter: 1500, exit: 2000 } }}
                open={open}
                autoHideDuration={3500}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                className={s.snackbar}
                TransitionComponent={Fade}
            >
                <div className={s.toast}>{message}</div>
            </Snackbar>
        </div>
    );
}
